import { Filter } from '@iot-platform/models/common';
import { I4BGridFilterOptions } from '@iot-platform/models/grid-engine';
import { DatePickerBatchFilter } from '../models';

export function isDatePickerBatchFilter(filter: any): filter is DatePickerBatchFilter {
  return filter?.isDatePickerBatch === true && !!filter?.fieldKey;
}

export function processDatePickerBatch(batchFilter: DatePickerBatchFilter, currentFilters: Filter[]): Filter[] {
  const { fieldKey, value, criteriaKey, criteriaLabel } = batchFilter;

  const filtersWithoutThisField = currentFilters.filter((f) => f.criteriaKey !== fieldKey);

  if (!value || Object.keys(value).length === 0) {
    return filtersWithoutThisField;
  }

  const newFilters = [];

  if (value.startDate?.value !== null && value.startDate?.value !== undefined && value.startDate.value !== '') {
    newFilters.push({
      criteriaKey,
      criteriaLabel,
      criteriaOperator: I4BGridFilterOptions.IN_RANGE_START,
      value: value.startDate.value,
      valueDisplay: value.startDate.valueDisplay,
      label: value.startDate.valueDisplay
    });
  }

  if (value.endDate?.value !== null && value.endDate?.value !== undefined && value.endDate.value !== '') {
    newFilters.push({
      criteriaKey,
      criteriaLabel,
      criteriaOperator: I4BGridFilterOptions.IN_RANGE_END,
      value: value.endDate.value,
      valueDisplay: value.endDate.valueDisplay,
      label: value.endDate.valueDisplay
    });
  }

  return [...filtersWithoutThisField, ...newFilters];
}
